export default {
  subscriptionPeriod: "setup/subscription-period",
  memberType: "setup/member-type",
  reviewers: "setup/reviewer",
  stages: "application/stage",
  reviewStages: "setup/stage",
  stagechecklists: "review/stage-checklist",
  submitStageChecklist: "review/submit-stage-checklist",
  profileDiscipline: "setup/profileDiscipline",
  getRecordedDocumentReviewChecklist: (params) =>
    `review/recorded-document-review-checklist?${getParams(params)}`,
};

function getParams(params) {
  return Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
}
